import { createAction } from 'redux-actions';
import { RESET, SET_LOADING, SET_PRODUCT } from './actionTypes';
import { getProductPortal } from './service';
import STATUS_CODE from '../../../request/statusCode';

const setProduct = createAction(SET_PRODUCT);

const reset = createAction(RESET);

const setLoading = createAction(SET_LOADING);

const getProduct = () => {
  return dispatch => {
    dispatch(setLoading(true));
    return getProductPortal().then(res => {
      dispatch(setLoading(false));
      if (res.statusCode === STATUS_CODE.OK) {
        return dispatch(setProduct(res.data));
      }
      return dispatch(setProduct({}));
    });
  };
};

export { setProduct, getProduct, reset, setLoading };
